import { render, staticRenderFns } from "./DocumentsStatements.vue?vue&type=template&id=173e65fd&scoped=true"
import script from "./DocumentsStatements.vue?vue&type=script&lang=js"
export * from "./DocumentsStatements.vue?vue&type=script&lang=js"
import style0 from "./DocumentsStatements.vue?vue&type=style&index=0&id=173e65fd&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173e65fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Generac.Application.MobileLink\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('173e65fd')) {
      api.createRecord('173e65fd', component.options)
    } else {
      api.reload('173e65fd', component.options)
    }
    module.hot.accept("./DocumentsStatements.vue?vue&type=template&id=173e65fd&scoped=true", function () {
      api.rerender('173e65fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AccountSettings/DocumentsStatements.vue"
export default component.exports